import * as React from 'react'
import { BehaviorSubject } from 'rxjs'
import { SCREEN } from './Srnka'
import Animal from './Animal'
import Tree from './Tree'
import Pond from './Pond'
import { FirebaseContext, ModelContext } from './Ctx'
import { firestore } from 'firebase'
import { subjectArrayToArray } from './utils'
import RenderSubject from './RenderSubject'

class Field extends React.PureComponent {
	state = {
		things: null
	}

	componentDidMount() {
		const subject = this.props.model.getCollectionByPath(
			`srnky/${this.props.data.id}/owns`
		)
		subject.subscribe({
			next: snapshot => {
				if (!snapshot) {
					return
				}
				const thingSubjects = []
				snapshot.forEach(doc => {
					thingSubjects.push(
						this.props.model.getDocByPath(doc.data().thing.path)
					)
				})
				this.setState({ things: subjectArrayToArray(thingSubjects) })
			}
		})
	}

	componentWillUnmount() {
		if (this.cancelSnapshots) {
			this.cancelSnapshots()
		}
	}

	render() {
		return (
			<div className="Field">
				{this.state.things && (
					<RenderSubject subject={this.state.things}>
						{things =>
							things.every(t => t !== null) &&
							(() => {
								const thingsData = things.map(t => t.data())
								const bow = thingsData.find(
									thing => thing.type === 'bow'
								)
								const pond = thingsData.find(
									thing => thing.type === 'pond'
								)
								const flowers = thingsData.find(
									thing => thing.type === 'flowers'
								)
								return (
									<div className="Canvas">
										{pond && <Pond />}
										<Animal
											bow={bow ? bow.color : false}
											flowers={flowers}
										/>
										<div>
											{thingsData
												.filter(
													thing =>
														thing.title === 'Strom'
												)
												.map((_, i) => (
													<Tree key={i} />
												))}
										</div>
									</div>
								)
							})()
						}
					</RenderSubject>
				)}

				<button
					className="LeftIconButton"
					onClick={e => {
						e.preventDefault()
						this.props.changeScreen(SCREEN.MARKET)
					}}
				>
					<i className="fa fa-shopping-basket" aria-hidden="true" />
				</button>
				<button
					className="RightIconButton"
					onClick={e => {
						e.preventDefault()
						this.props.changeScreen(SCREEN.QUIZ)
					}}
				>
					<i className="fa fa-question" aria-hidden="true" />
				</button>
			</div>
		)
	}
}

export default props => (
	<ModelContext.Consumer>
		{model => (
			<FirebaseContext.Consumer>
				{firebase => (
					<Field {...props} firebase={firebase} model={model} />
				)}
			</FirebaseContext.Consumer>
		)}
	</ModelContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/Field.js